"use client"

import * as React from "react"

import { Calendar as UiCalendar } from "@/components/ui/calendar"
import { cn } from "@/lib/utils"

function Calendar({
  className,
  ...props
}: React.ComponentProps<typeof UiCalendar>) {
  return <UiCalendar className={cn(className)} {...props} />
}

export { Calendar }
